export default "__VITE_ASSET__$UMMgw4c__"